import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import timezones from '../../utils/timezones.json';

const TimeTemplate = () => {
  const dispatch = useDispatch();
  const { time_template_id } = useParams();
  const { timeTemplate, loadingTimeTemplate } = useSelector((state) => state.general);

  const [name, setName] = useState(undefined);
  const [changeNameClicked, setChangeNameClicked] = useState(false);
  const [timezone, setTimezone] = useState(undefined);
  const [changeTimezoneClicked, setChangeTimezoneClicked] = useState(false);
  const [specificTime, setSpecificTime] = useState([]);
  const [rangeStartHour, setRangeStartHour] = useState(0);
  const [rangeEndHour, setRangeEndHour] = useState(0);
  const [rangeInterval, setRangeInterval] = useState(15);
  const [showRangeSelector, setShowRangeSelector] = useState(false);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'timeTemplate',
        route: 'timeTemplates/getTimeTemplateById',
        id: time_template_id,
      }),
    );
  }, [dispatch, time_template_id]);

  useEffect(() => {
    if (timeTemplate?._id) {
      setName(timeTemplate.name);
      setSpecificTime(
        timeTemplate.template?.map((time) => {
          return { ...time, id: time._id };
        }) || [],
      );
      setTimezone(timeTemplate.timezone);
    }
  }, [dispatch, timeTemplate]);

  console.log({ timeTemplate, specificTime, timezone });
  return timeTemplate?._id && Array.isArray(specificTime) ? (
    <>
      <div>
        <Link className='btn btn-outline-dark' to='/timetemplates'>
          Back to Templates
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>Edit Time Template</h1>
        </div>
        <div className='row d-flex justify-content-center'>
          {changeTimezoneClicked ? (
            <>
              <Select
                className='col-md-6'
                options={timezones.map((timezone) => ({
                  value: timezone.abbr,
                  label: `${timezone.text} (${timezone.abbr}) - ${timezone.value}`,
                }))}
                value={timezone}
                placeholder='Search or select a timezone'
                onChange={(selectedOption) => {
                  setTimezone(typeof selectedOption.value === 'string' ? selectedOption.value : 'UTC');
                  setChangeTimezoneClicked(false);
                }}
                isSearchable
              />
            </>
          ) : (
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => setChangeTimezoneClicked(true)}
              title='Click to Change Timezone'
            >
              <b>Timezone:</b> {timezone}
            </span>
          )}
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          {changeNameClicked ? (
            <>
              <div className='col-md-5'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Template name...'
                  style={{ textAlign: 'center' }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </>
          ) : (
            <>
              <h3 className='text-primary mr-2'>{name}</h3>
              <upper>
                <i title='Edit Name' className='fas fa-edit pointer' onClick={() => setChangeNameClicked(true)}></i>
              </upper>
            </>
          )}
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-12 d-flex justify-content-center'>
            <small>
              <b>Note: </b> All times are under UTC timzone{' '}
            </small>
          </div>
          <div className='col-md-12 d-flex justify-content-center mt-2'>
            <label className='d-flex align-items-center'>
              <input
                type='checkbox'
                className='mr-2'
                checked={showRangeSelector}
                onChange={(e) => setShowRangeSelector(e.target.checked)}
              />
              Show range selector
            </label>
          </div>
          {showRangeSelector && (
            <div id='rangeSelector' className='col-md-12 p-3 border mb-2'>
              <div className='d-flex justify-content-between align-items-center'>
                From:{' '}
                <select
                  className='m-2 form-control'
                  value={rangeStartHour}
                  onChange={(e) => setRangeStartHour(parseInt(e.target.value) || 0)}
                >
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={`start-${i}`} value={i}>
                      {i}
                    </option>
                  ))}
                </select>
                To:{' '}
                <select
                  className='m-2 form-control'
                  value={rangeEndHour}
                  onChange={(e) => setRangeEndHour(parseInt(e.target.value) || 0)}
                >
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={`end-${i}`} value={i}>
                      {i}
                    </option>
                  ))}
                </select>
                Interval:{' '}
                <select
                  className='m-2 form-control'
                  value={rangeInterval}
                  onChange={(e) => setRangeInterval(parseInt(e.target.value) || 15)}
                >
                  <option value={15}>15</option>
                  <option value={30}>30</option>
                  <option value={45}>45</option>
                  <option value={60}>60</option>
                </select>
              </div>
              <button
                className='btn btn-outline-dark mt-2'
                onClick={() => {
                  const start = Math.min(rangeStartHour, rangeEndHour);
                  const end = Math.max(rangeStartHour, rangeEndHour);
                  const interval = rangeInterval;
                  const additions = [];
                  for (let h = start; h <= end; h++) {
                    for (let m = 0; m < 60; m += interval) {
                      const exists = specificTime.some(
                        (t) => parseInt(t.hour) === h && (parseInt(t.minute) || 0) === m,
                      );
                      if (!exists) {
                        additions.push({ id: Date.now() + additions.length + h * 60 + m, hour: h, minute: m });
                      }
                    }
                  }
                  if (additions.length > 0) {
                    setSpecificTime([...specificTime, ...additions]);
                  }
                }}
              >
                Add Range
              </button>
            </div>
          )}

          <div className='col-md-4'>
            {specificTime.map((time) => (
              <div key={time.id || time._id} className='d-flex justify-content-between align-items-center'>
                <select
                  className='form-control'
                  value={time.hour}
                  onChange={(e) => {
                    setSpecificTime(
                      specificTime.map((t) => {
                        return t.id === time.id ? { ...t, hour: parseInt(e.target.value) || 0 } : t;
                      }),
                    );
                  }}
                >
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={i}>
                      {i}
                    </option>
                  ))}
                </select>
                <select
                  className='form-control'
                  value={time.minute || 0}
                  onChange={(e) => {
                    setSpecificTime(
                      specificTime.map((t) => {
                        return t.id === time.id ? { ...t, minute: parseInt(e.target.value) || 0 } : t;
                      }),
                    );
                  }}
                >
                  <option value={0}>00</option>
                  <option value={15}>15</option>
                  <option value={30}>30</option>
                  <option value={45}>45</option>
                </select>
                <button
                  className='btn btn-outline-danger'
                  onClick={() => setSpecificTime(specificTime.filter((t) => t.id !== time.id))}
                >
                  <i className='fa fa-trash' aria-hidden='true'></i>
                </button>
              </div>
            ))}
            <button
              className='btn btn-outline-dark mt-2'
              onClick={() => setSpecificTime([...specificTime, { id: Date.now(), hour: 12, minute: 0 }])}
            >
              Add Time
            </button>
          </div>
        </div>
        {typeof name === 'string' && name.length > 0 && specificTime.length > 0 ? (
          <div className='row d-flex justify-content-center mt-4 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
            <button
              className='btn btn-outline-dark'
              disabled={loadingTimeTemplate}
              onClick={() => {
                dispatch(generalSet({ reduxField: 'loadingTimeTemplate', value: true }));
                dispatch(
                  apiAction({
                    route: 'timeTemplates/updateTimeTemplate',
                    reduxField: 'timeTemplate',
                    id: time_template_id,
                    name,
                    template: specificTime.map((time) => {
                      return { hour: time.hour, minute: time.minute };
                    }),
                    timezone,
                    setLoading: 'loadingTimeTemplate',
                  }),
                );
                setChangeNameClicked(false);
                setChangeTimezoneClicked(false);
              }}
            >
              {loadingTimeTemplate ? <Spinner /> : 'Save Template'}
            </button>
          </div>
        ) : null}
      </div>
    </>
  ) : (
    <Spinner />
  );
};

export default TimeTemplate;
